function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import AsyncStorage from "@react-native-async-storage/async-storage";
import * as Sentry from "@sentry/core";
import { AsyncStorageWrapper, CachePersistor, MMKVWrapper } from "apollo3-cache-persist";
import { Linking, Platform } from "react-native";
import Url from "url-parse";
import { createApolloCache, createApolloClient } from "./apolloClient";
import { getMmkv } from "./mmkv";
import { getConfigString, initLastConfig } from "./remoteConfig";
import { IS_PRODUCTION } from "../constants";
/**
 * Initializes an `ApolloClient` for use with our GraphQL API.
 *
 * A `CachePersistor` is initialized which is responsible for
 * persisting/restoring the client's cache data on clients with support for
 * secure, on-device storage of data.
 *
 * Web platform does not support secure storage, but we allow storage in
 * non-production environments so that we can more closely match behavior on
 * the iOS and Android platforms during development.
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-156}
 */ export function initApollo(onRegisterCleanup) {
    return _initApollo.apply(this, arguments);
}
function _initApollo() {
    _initApollo = _async_to_generator(function(onRegisterCleanup) {
        var cache, options, persistor, e, apiUrl, query, _, client, start, removedKeys, duration;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    cache = createApolloCache();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    options = Platform.OS === 'web' ? IS_PRODUCTION ? undefined : {
                        cache: cache,
                        trigger: 'write',
                        storage: new AsyncStorageWrapper(AsyncStorage)
                    } : {
                        cache: cache,
                        trigger: 'background',
                        storage: new MMKVWrapper(getMmkv('apollo'))
                    };
                    if (!options) return [
                        3,
                        3
                    ];
                    persistor = new CachePersistor(options);
                    return [
                        4,
                        persistor.restore()
                    ];
                case 2:
                    _state.sent();
                    onRegisterCleanup(function() {
                        return persistor.remove();
                    });
                    _state.label = 3;
                case 3:
                    return [
                        3,
                        5
                    ];
                case 4:
                    e = _state.sent();
                    Sentry.captureException(e);
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        4,
                        initLastConfig()
                    ];
                case 6:
                    _state.sent();
                    apiUrl = getConfigString('apiUrl');
                    if (!!IS_PRODUCTION) return [
                        3,
                        8
                    ];
                    _ = Url.bind;
                    return [
                        4,
                        Linking.getInitialURL()
                    ];
                case 7:
                    query = (new (_.apply(Url, [
                        void 0,
                        _state.sent(),
                        {},
                        {
                            parser: true
                        }
                    ]))).query;
                    apiUrl = query.apiUrl || apiUrl;
                    _state.label = 8;
                case 8:
                    client = createApolloClient(apiUrl, {
                        subscriptionUri: getConfigString('subscriptionUri'),
                        cache: cache,
                        connectToDevTools: process.env.NODE_ENV !== 'test'
                    });
                    start = Date.now();
                    removedKeys = cache.gc();
                    duration = Date.now() - start;
                    Sentry.addBreadcrumb({
                        category: 'apollo',
                        message: 'cache.gc',
                        data: {
                            removedKeys: removedKeys,
                            duration: duration
                        }
                    });
                    return [
                        2,
                        client
                    ];
            }
        });
    });
    return _initApollo.apply(this, arguments);
}
